import { render, staticRenderFns } from "./viewfeespayments.vue?vue&type=template&id=873eff46&"
import script from "./viewfeespayments.vue?vue&type=script&lang=js&"
export * from "./viewfeespayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports